'use strict'

import Actu from './components/Actu';   
import Clients from './components/Clients';  
import CustomFullPagejs from "./components/CustomFullPagejs";
import CustomMap from './components/CustomMap'; 
import Footer from './components/Footer';
import Partners from './components/Partners';
import Stats from './components/Stats';   
import Mentions from './components/Mentions';   
import Header from './components/Header';
import Filiale from './components/Filiale';
import Press from './components/Press';


const beforeFullPageRender = () => {
  const BSClients = new Clients()
  BSClients.setFullPage();
  const BSActu = new Actu()
  BSActu.setSlick();
  const BSStats = new Stats()
  BSStats.setSlick();
  const BSFooter = new Footer()
  BSFooter.setFullPage();
  const BSPartners = new Partners()
  BSPartners.setHover();
  const BSMentions = new Mentions();
  BSMentions.init();
  const BSHeader = new Header();
  BSHeader.init();
  const BSFiliale = new Filiale();
  BSFiliale.init();
  const BSPress = new Press();
  BSPress.init();
}
window.addEventListener('DOMContentLoaded', () => {
    beforeFullPageRender()
    const FullPagejs = new CustomFullPagejs()
    FullPagejs.renderFullpage()

    const Map = new CustomMap()
    Map.toggleDisplay()
    Map.setCursor();

    const mapHeader = document.querySelectorAll('.mapContainer header');
    
    setTimeout(function() {
      mapHeader.forEach(function(element) {
        element.removeAttribute("hidden"); 
      });
    }, 2000);
});


// WEBPACK FOOTER //
// ./src/scripts/main.js